export const SELECT_REPORTING_MENU_OPTION = 'SELECT_REPORTING_MENU_OPTION';

export const selectReportingMenuOption = selectedMenuOption => ({
  type: SELECT_REPORTING_MENU_OPTION,
  selectedMenuOption,
});
